
export const copyText = async (text: string): Promise<boolean> => {
  // iOS Safari 特殊处理
  if (/iPhone|iPad|iPod|Safari/.test(navigator.userAgent)) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    
    // 确保文本框可见且可交互，但不影响布局
    textarea.style.cssText = 'position:fixed;top:0;left:0;opacity:0;z-index:-1;';
    textarea.style.userSelect = 'text';  // 确保文本可选
    
    document.body.appendChild(textarea);
    
    try {
      textarea.focus();
      textarea.select();
      
      // iOS 需要特殊处理选区
      textarea.setSelectionRange(0, textarea.value.length);
      
      const successful = document.execCommand('copy');
      if (!successful) {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    } finally {
      document.body.removeChild(textarea);
    }
  }

  // 其他浏览器优先使用 Clipboard API
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (err) {
    // Clipboard API failed
  }

  // 通用降级方案
  const textarea = document.createElement('textarea');
  textarea.value = text;
  
  textarea.style.cssText = 'position:fixed;top:0;left:0;opacity:0;z-index:-1;';
  document.body.appendChild(textarea);
  
  try {
    textarea.focus();
    textarea.select();
    
    const successful = document.execCommand('copy');
    if (!successful) {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  } finally {
    document.body.removeChild(textarea);
    window.getSelection()?.removeAllRanges();
  }
};